export default {
    logando: false,
    login: {}
}